import { useParams } from "react-router-dom";

interface UseParamsType {
  questionId?: string;
}

export default function QuestionIdParams() {
  return Number(useParams<UseParamsType>()["questionId"]);
}
